module.exports = __webpack_public_path__ + "img/p0.c330a643.png";